import type { GenericAttachment } from '@/styles/GenericAttachmentsSection';
import { uploadEntityAttachments, fetchEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';

// Project attachments: the shared implementation (lib/entity-attachments.ts)
// -- this file only names the entity type these files belong to.
const ENTITY_TYPE = 'project';

export type ProjectFileAttachment = GenericAttachment;

export function uploadProjectAttachments(parentId: string | undefined, files: File[], companyId: string, userId: string): Promise<ProjectFileAttachment[]> {
  return uploadEntityAttachments(ENTITY_TYPE, parentId, files, companyId, userId);
}

export function fetchProjectAttachments(parentId: string, opts?: { ascending?: boolean }): Promise<ProjectFileAttachment[]> {
  // Newest first (the Projects list/form has always shown them that way).
  return fetchEntityAttachments(ENTITY_TYPE, parentId, { ascending: false, ...opts });
}

export function deleteProjectAttachment(attachmentId: string, userId: string | undefined): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}
